import { seededRandom } from './random';

// Procedural skyline rendered as an SVG data URI, used as a section background.
// layers: [{ w: [min, max], h: [min, max], fill, stroke?, strokeOpacity?, windows?, windowColor?, gap?, rise? }]
// options: { grid?: boolean, cranes?: boolean }
const WIDTH = 1600;
const HEIGHT = 900;

export const GRADIENTS = {
  night: [['0', '#030807'], ['1', '#0d2624']],
  green: [['0', '#06100f'], ['.6', '#123332'], ['1', '#2a6b56']],
  dusk: [['0', '#0b1f1e'], ['.55', '#1d4a44'], ['1', '#b8974a']],
};

export function skylineBackground({ seed, gradient = GRADIENTS.night, layers = [], options = {} }) {
  const rand = seededRandom(seed);
  let body = '';

  if (options.grid) {
    for (let x = 0; x <= WIDTH; x += 80) body += `<path d="M${x} 0V${HEIGHT}" stroke="#8fe0c4" stroke-opacity=".1"/>`;
    for (let y = 0; y <= HEIGHT; y += 45) body += `<path d="M0 ${y}H${WIDTH}" stroke="#8fe0c4" stroke-opacity=".1"/>`;
  }

  layers.forEach((layer) => {
    for (let x = -30; x < WIDTH + 30; ) {
      const w = layer.w[0] + rand() * (layer.w[1] - layer.w[0]);
      let h = layer.h[0] + rand() * (layer.h[1] - layer.h[0]);
      if (layer.rise) h *= 0.3 + (1.2 * x) / WIDTH;
      const y = HEIGHT - h;
      const stroke = layer.stroke
        ? ` stroke="${layer.stroke}" stroke-opacity="${layer.strokeOpacity || 0.6}" stroke-width="2"`
        : '';
      body += `<rect x="${x.toFixed(0)}" y="${y.toFixed(0)}" width="${w.toFixed(0)}" height="${h.toFixed(0)}" fill="${layer.fill}"${stroke}/>`;

      if (layer.windows) {
        for (let wy = y + 16; wy < HEIGHT - 20; wy += 30) {
          for (let wx = x + 10; wx < x + w - 14; wx += 22) {
            if (rand() < layer.windows) {
              body += `<rect x="${wx.toFixed(0)}" y="${wy.toFixed(0)}" width="9" height="13" fill="${layer.windowColor || '#d4af37'}" fill-opacity="${(0.3 + rand() * 0.55).toFixed(2)}"/>`;
            }
          }
        }
      }
      x += w + (layer.gap || 4);
    }
  });

  if (options.cranes) {
    [260, 820, 1300].forEach((cx, i) => {
      const cy = 230 + i * 60;
      body += `<path d="M${cx} ${HEIGHT}V${cy}M${cx - 120} ${cy}H${cx + 220}M${cx} ${cy - 50}L${cx - 120} ${cy}M${cx} ${cy - 50}L${cx + 220} ${cy}M${cx + 170} ${cy}V${cy + 110}" stroke="#d4af37" stroke-opacity=".75" stroke-width="5" fill="none"/>`;
    });
  }

  const stops = gradient.map(([offset, color]) => `<stop offset="${offset}" stop-color="${color}"/>`).join('');
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${WIDTH} ${HEIGHT}"><defs><linearGradient id="s" x1="0" y1="0" x2="0" y2="1">${stops}</linearGradient></defs><rect width="${WIDTH}" height="${HEIGHT}" fill="url(#s)"/>${body}</svg>`;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
}
